import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Practitioner } from 'src/app/core/model/v2/practitioner/practitioner';
import { PractitionerSymptom } from 'src/app/core/model/v2/practitioner/practitioner-symptom';
import { PractitionerSymptomsUpdate } from 'src/app/core/model/v2/practitioner/practitioner-symptoms-update';
import { Symptom } from 'src/app/core/model/v2/practitioner/symptom';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-symptoms',
  templateUrl: './symptoms.component.html',
  styleUrls: ['./symptoms.component.scss']
})
export class SymptomsComponent implements OnInit {

  @Input() practitioner: Practitioner;
  symptomsOptions: Symptom[];
  practitionerSyptoms: Symptom[];
  newSymptomName:string;
  @ViewChild('symptomsSearchInput', { static: true }) symptomsSearchInput: ElementRef;

  constructor(private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {

    // this.getPractitionerSymptoms(this.practitioner.Id);

    fromEvent(this.symptomsSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.getSymptomsByName(text);
    });

  }
  deletePractitionerSymptom(symptom):void{
    this.loaderService.show();
    this.practiceService.deletePractitionerSymptom(symptom.id).subscribe(
      (_) => { 

        this.practitioner.practitionerSymptoms=this.practitioner.practitionerSymptoms.filter(i=>i.symptom.code!==symptom.symptom.code);

        this.loaderService.hide(); },
      (error) => { console.error(error); this.loaderService.hide(); },
      () => { this.loaderService.hide(); });
  }
  getPractitionerSymptoms(practitionerId: number): void {
    this.loaderService.show();
    this.practiceService.getPractitionerSymptoms(practitionerId).subscribe(
      (symp) => {
        this.loaderService.hide();
        if (symp) {
          this.practitionerSyptoms = symp;
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); },
    )
  }

  getSymptomsByName(name: string): void {
    this.loaderService.show();
    this.practiceService.getSymptomsByName(name).subscribe(
      (symp) => {
        this.loaderService.hide();
        if (symp) {
          this.symptomsOptions = symp;
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); },
    )
  }
  addnewSymptom():void{
    this.loaderService.show();
    this.practiceService.addnewSymptom(this.newSymptomName).subscribe(
      (symp) => {
        this.loaderService.hide();
        if (symp) {
          if(symp.resultStatus.isSuccess) 
{
  this.newSymptomName=null;
 this.selectSymptom(symp.result);
}          
          //this.treatmentsOptions = symp;
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); },
    )
  }
  selectSymptom(symptom: Symptom): void {
    const practitionerSymptom = new PractitionerSymptom();
    practitionerSymptom.practitioner = this.practitioner;
    practitionerSymptom.practitionerId = this.practitioner.id;
    practitionerSymptom.symptom = symptom;
    practitionerSymptom.symptomId = symptom.id;
    if(this.practitioner.practitionerSymptoms.find(x=>x.symptom.code==symptom.code)==null){
    this.practitioner.practitionerSymptoms.push(practitionerSymptom);

    const symptomUpdate = new PractitionerSymptomsUpdate();
    symptomUpdate.practitionerId = this.practitioner.id;
    symptomUpdate.symptomIds = [];
    this.practitioner.practitionerSymptoms.forEach(x => {
      symptomUpdate.symptomIds.push(x.symptomId);
    });

    this.loaderService.show();
    this.practiceService.addOrUpdateSymptoms(symptomUpdate).subscribe(
      (res)=>{
        this.snackBar.open(`Symptom added to ${this.practitioner.fullName}.`, 'Ok');
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); },
    )    
  }
  else{
    this.snackBar.open(`Already existed to ${this.practitioner.fullName}.`, 'Ok');
        //this.loaderService.hide();
  }
}
}
